import {memo} from 'react'

/* @autogenerated optimization completed by @naverpay/optimize-svg-components */
import {SvgUniqueID} from '@naverpay/svg-manager'

import type {SVGStyleProps} from '@naverpay/svg-manager'

const IconNone = memo(({width = '100%', height = '100%', viewBox = '0 0 22 21', id, style = {}}: SVGStyleProps) => (
    <SvgUniqueID id={id}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            style={style}
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.96793 10.0891L3.9397 5.06075L6.06104 2.93945L11.0892 7.96775L16.1174 2.93945L18.2388 5.06075L13.2105 10.0891L18.2385 15.1172L16.1172 17.2385L11.0892 12.2104L6.06129 17.2385L3.93995 15.1172L8.96793 10.0891Z"
                fill="#F73631"
            />
        </svg>
    </SvgUniqueID>
))

export default IconNone
